import React, { useRef, useState } from "react";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import { validateForm } from "../../utils/validate";
import sapien from "../../assets/sapiens.png";

const Contact = () => {

  const [showFullNameError, setShowFullNameError] = useState(false);
  const [showMobileError, setMobileError] = useState(false);
  const [showEmailError, setShowEmailError] = useState(false);
  const [showOrgNameError, setOrgNameError] = useState(false);
  const [showMessageError, setMessageError] = useState(false);

  const [state, setState] = useState({
    open: false,
    vertical: "bottom",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;

  const fullName = useRef(null);
  const mobile = useRef(null);
  const email = useRef(null);
  const org_name = useRef(null);
  const message = useRef(null);

  const handleCloseSnackBar = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setState({ vertical: "bottom", horizontal: "center", open: false });
  };

  const clearForm = () => {
    document.getElementById("contact-form").reset();
  };

  const submitInfo = async () => {
    const validateObj = validateForm(
      fullName.current.value,
      mobile.current.value,
      email.current.value,
      org_name.current.value,
      message.current.value
    );
    if (!validateObj.fullName) {
      setShowFullNameError(true);
    } else {
      setShowFullNameError(false);
    }

    if (!validateObj.mobile) {
      setMobileError(true);
    } else {
      setMobileError(false);
    }

    if (!validateObj.email) {
      setShowEmailError(true);
    } else {
      setShowEmailError(false);
    }

    if (!validateObj.org) {
      setOrgNameError(true);
    } else {
      setOrgNameError(false);
    }

    if (!validateObj.message) {
      setMessageError(true);
    } else {
      setMessageError(false);
    }

    if (
      (validateObj.fullName &&
      validateObj.mobile &&
      validateObj.email &&
      validateObj.org &&
      validateObj.message)
    ) {
      const obj = {
        customerName: fullName.current.value,
        mobNumber: mobile.current.value,
        email: email.current.value,
        orgName: org_name.current.value,
        details: message.current.value,
      };


      const data = await fetch(
        "https://flintinfotech.com/websitecontactus/saveContactDetails",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
          body: JSON.stringify(obj),
        }
      );
      clearForm();

      setState({ vertical: "bottom", horizontal: "center", open: true });
    }
  };

  return (
    <div className="px-5 sm:px-20 mt-10 py-10" id="contact">
      <p className="text-center text-[#333e49] text-2xl sm:text-4xl poppins-semibold">
        Get in touch
      </p>
      <div className="flex flex-col sm:flex-row justify-between mt-10">
        <div className="w-full sm:w-1/2 px-2 sm:px-10">
          {/* <p className="font-notosans text-slate-400 text-2xl text-center sm:text-6xl sm:leading-[70px]">
            The perfect partner for your digital pivot
          </p>
          <p className="font-notosans text-black text-3xl text-center sm:text-6xl font-bold leading-[70px]">
            Get in touch
          </p> */}

          <img src={sapien} />
        </div>

        <div className="w-full sm:w-1/2">
          <Paper className="bg-[#F8FAFB] py-3" elevation={3}>
            <p className="font-notosans text-black text-xl sm:text-4xl font-bold leading-[70px] text-center">
              Write us a message
            </p>
            <form className="mt-5" onSubmit={(e) => e.preventDefault()} id="contact-form">
              <div className="px-5 sm:px-24">
                <div className="my-3">
                  <input
                    ref={fullName}
                    type="text"
                    placeholder="Full Name"
                    className="border-[1px] border-slate-400 outline-none rounded-md w-full px-2 py-3"
                  />
                  {showFullNameError && (
                    <p className="text-red-700 font-semibold px-1 mt-1 text-sm">
                      Please Enter Full Name
                    </p>
                  )}
                </div>

                <div className="my-3">
                  <input
                    ref={mobile}
                    type="number"
                    placeholder="Mobile Number"
                    className="border-[1px] border-slate-400 outline-none rounded-md w-full px-2 py-3"
                  />
                  {
                    showMobileError &&  <p className="text-red-700 font-semibold px-1 mt-1 text-sm">
                      Please Enter valid Mobile Number
                    </p>
                  }
                </div>

                <div className="my-3">
                  <input
                    ref={email}
                    type="email"
                    placeholder="Email"
                    className="border-[1px] border-slate-400 outline-none rounded-md w-full px-2 py-3"
                  />
                  {
                    showEmailError &&  <p className="text-red-700 font-semibold px-1 mt-1 text-sm">
                      Please Enter valid Email
                    </p>
                  }
                </div>
                <div className="my-3">
                  <input
                    ref={org_name}
                    type="text"
                    placeholder="Organization Name"
                    className="border-[1px] border-slate-400 outline-none rounded-md w-full px-2 py-3"
                  />
                  {
                    showOrgNameError &&  <p className="text-red-700 font-semibold px-1 mt-1 text-sm">
                      Please Enter Organization Name
                    </p>
                  }
                </div>
                <div className="my-3">
                  <textarea
                    ref={message}
                    type="text"
                    placeholder="Message"
                    className="border-[1px] border-slate-400 outline-none rounded-md w-full px-2 py-3"
                  />

                  {
                    showMessageError &&  <p className="text-red-700 font-semibold px-1 mt-1 text-sm">
                      Please Enter Message
                    </p>
                  }
                </div>

                <div className=" flex justify-end">
                  <Button
                    variant="contained"
                    disabled={false}
                    onClick={() => submitInfo()}
                  >
                    Send a message
                  </Button>
                </div>
              </div>
            </form>
          </Paper>
        </div>
      </div>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={open}
        onClose={handleCloseSnackBar}
        message="Thank you for reaching out to Fint Infotech. Team will contact you soon."
        key={vertical + horizontal}
        autoHideDuration={3000}
      />
    </div>
  );
};

export default Contact;
